import React from 'react'
/**
 * ExchangeIcon component renders an SVG icon representing an exchange.
 *
 * @param {Object} props - Properties passed to the SVG element.
 * @param {string} [props.className] - Optional class name for the SVG element.
 * @param {string} [props.fill] - Optional fill color for the SVG element.
 * @param {string} [props.stroke] - Optional stroke color for the SVG element.
 * @param {number} [props.strokeWidth] - Optional stroke width for the SVG element.
 * @param {string} [props.width] - Optional width for the SVG element.
 * @param {string} [props.height] - Optional height for the SVG element.
 * @param {string} [props.viewBox] - Optional viewBox attribute for the SVG element.
 * @param {Object} [props.style] - Optional style object for the SVG element.
 * @returns {JSX.Element} The rendered SVG element.
 */
const ExchangeIcon = props => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      {...props}
    >
      <ellipse
        cx="4.58333"
        cy="16.4998"
        rx="1.83333"
        ry="1.83333"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <ellipse
        cx="17.4167"
        cy="5.49984"
        rx="1.83333"
        ry="1.83333"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.1667 7.3335C18.1667 6.91928 17.8309 6.5835 17.4167 6.5835C17.0025 6.5835 16.6667 6.91928 16.6667 7.3335H18.1667ZM10.0834 16.5002L9.55304 15.9698C9.33855 16.1843 9.27438 16.5069 9.39046 16.7872C9.50655 17.0674 9.78003 17.2502 10.0834 17.2502V16.5002ZM13.3637 14.2805C13.6566 13.9876 13.6566 13.5127 13.3637 13.2198C13.0708 12.9269 12.5959 12.9269 12.303 13.2198L13.3637 14.2805ZM12.303 19.7805C12.5959 20.0734 13.0708 20.0734 13.3637 19.7805C13.6566 19.4876 13.6566 19.0127 13.3637 18.7198L12.303 19.7805ZM10.6137 15.9698C10.3208 15.6769 9.84594 15.6769 9.55304 15.9698C9.26015 16.2627 9.26015 16.7376 9.55304 17.0305L10.6137 15.9698ZM16.6667 7.3335V11.9168H18.1667V7.3335H16.6667ZM16.6667 11.9168C16.6667 14.0339 14.9505 15.7502 12.8334 15.7502V17.2502C15.7789 17.2502 18.1667 14.8623 18.1667 11.9168H16.6667ZM12.8334 15.7502H10.0834V17.2502H12.8334V15.7502ZM10.6137 17.0305L13.3637 14.2805L12.303 13.2198L9.55304 15.9698L10.6137 17.0305ZM13.3637 18.7198L10.6137 15.9698L9.55304 17.0305L12.303 19.7805L13.3637 18.7198Z"
        fill="currentColor"
      />
      <path
        d="M3.83337 14.6667C3.83337 15.0809 4.16916 15.4167 4.58337 15.4167C4.99759 15.4167 5.33337 15.0809 5.33337 14.6667H3.83337ZM11.9167 5.5V6.25C12.2201 6.25 12.4935 6.06727 12.6096 5.78701C12.7257 5.50676 12.6615 5.18417 12.447 4.96967L11.9167 5.5ZM9.69704 2.21967C9.40414 1.92678 8.92927 1.92678 8.63638 2.21967C8.34348 2.51256 8.34348 2.98744 8.63638 3.28033L9.69704 2.21967ZM8.63638 7.71967C8.34348 8.01256 8.34348 8.48744 8.63638 8.78033C8.92927 9.07322 9.40414 9.07322 9.69704 8.78033L8.63638 7.71967ZM12.447 6.03033C12.7399 5.73744 12.7399 5.26256 12.447 4.96967C12.1541 4.67678 11.6793 4.67678 11.3864 4.96967L12.447 6.03033ZM5.33337 14.6667V10.0833H3.83337V14.6667H5.33337ZM5.33337 10.0833C5.33337 7.96624 7.04962 6.25 9.16671 6.25V4.75C6.22119 4.75 3.83337 7.13781 3.83337 10.0833H5.33337ZM9.16671 6.25H11.9167V4.75H9.16671V6.25ZM12.447 4.96967L9.69704 2.21967L8.63638 3.28033L11.3864 6.03033L12.447 4.96967ZM9.69704 8.78033L12.447 6.03033L11.3864 4.96967L8.63638 7.71967L9.69704 8.78033Z"
        fill="currentColor"
      />
    </svg>
  )
}

export default ExchangeIcon
